import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authFetch } from '../../api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const res = await authFetch('sign-in/email', {
      method: 'POST',
      body: JSON.stringify({ email, password })
    });

    if (res?.status === 'success') {
      localStorage.setItem('user_id', res.data.user.id);
      window.location.href = '#/portal';
      window.location.reload(); 
    } else {
      setError(res.error || 'Något gick fel vid inloggning.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-4 font-sans text-stone-900">
      <div className="max-w-md w-full bg-white p-8 border border-stone-200 shadow-sm">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block mb-6">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/5c1e3a15fc68e7fca62dc4ec64936fd2c3f13f974599de31727b7a91865820cd8939af7242306cdc50be50497057948e/images/aW1hZ2UvcG5n/d6937394eb4d6a56959e8c727708d311.png" 
              alt="Logo" 
              className="h-10 w-auto mx-auto"
            />
          </Link>
          <h2 className="text-3xl font-serif mb-2">Välkommen tillbaka</h2>
          <p className="text-stone-500 font-light text-sm">Logga in till din portal</p>
        </div>
        
        {error && <div className="mb-4 p-3 bg-red-50 text-red-600 text-sm">{error}</div>}
        
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-widest text-stone-500 mb-2">E-post</label>
            <input 
              type="email" 
              required
              className="w-full px-4 py-3 border border-stone-200 focus:border-stone-900 focus:outline-none transition-colors"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <div className="flex justify-between items-center mb-2">
                <label className="block text-xs uppercase tracking-widest text-stone-500">Lösenord</label>
                <Link to="/forgot-password" className="text-xs text-stone-500 hover:text-stone-900">Glömt lösenord?</Link>
            </div>
            <input 
              type="password" 
              required
              className="w-full px-4 py-3 border border-stone-200 focus:border-stone-900 focus:outline-none transition-colors"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button 
            type="submit" 
            disabled={loading}
            className="w-full py-4 bg-stone-900 text-white text-xs uppercase tracking-widest hover:bg-stone-800 transition-colors disabled:opacity-50 mt-4"
          >
            {loading ? 'Loggar in...' : 'Logga in'}
          </button>
        </form>
        
        <div className="mt-8 text-center text-sm text-stone-500 font-light">
          Har du inget konto? <Link to="/signup" className="text-stone-900 font-medium hover:underline">Skapa konto</Link>
        </div>
      </div>
    </div>
  );
}